import { render, staticRenderFns } from "./DigitalWallet.vue?vue&type=template&id=21b173e6&scoped=true&"
import script from "./DigitalWallet.vue?vue&type=script&lang=js&"
export * from "./DigitalWallet.vue?vue&type=script&lang=js&"
import style0 from "./DigitalWallet.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DigitalWallet.vue?vue&type=style&index=1&id=21b173e6&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b173e6",
  null
  
)

export default component.exports